import PropTypes from 'prop-types'
import Styles from './UserPageTab.module.css'
import { IFText } from 'Components'
import { Colors } from 'Theme'

const UserPageTab = ({ title, isSelected }) => {
  return (
    <div className={Styles.Container}>
      <IFText
        style={{ color: isSelected ? Colors.text : Colors.NotSelectedText }}
        className={Styles.UserPageTabTitle}
      >
        {title}
      </IFText>
    </div>
  )
}

UserPageTab.propTypes = {
  title: PropTypes.string,
  isSelected: PropTypes.bool,
}

export default UserPageTab
